module.exports = __webpack_public_path__ + "static/media/Assets-02-HRA-01.7b99ddeb.png";